<template>
  <div class="my-promotion" v-if="isshow">
    <div class="promo-top">
		<div class="top-top">
			<div class="top-left"><img :src="userInfo.userinfo.avatar" alt=""></div>
			<div class="top-right">
				<h2>{{ userInfo.userinfo.nickname }}</h2>
				<p>当前店铺：{{ userInfo.site_name }}</p>
			</div>
		</div>
		<div class="top-bottom" v-if="userInfo.level_info">
			<p class="bottom-title">
				<span class="title-l">{{ userInfo.level_info.name }}</span>
				<span class="title-r" @click="$router.push('/user/grade_center')">进入等级中心<i class="iconfont icon-jiantou"></i></span>
			</p>
			<p v-if="userInfo.upgrade.next_name" class="bottom-i">推广金额再增加{{ userInfo.upgrade.differ }}元即可升级为{{ userInfo.upgrade.next_name }}</p>
		</div>
	</div>
	<div class="promo-content">
		<div class="content-a">
			<ul>
				<li @click="toCommission('total')">
					<p class="strong">{{ userInfo.commissionCount }}</p>
					<p class="gray">累计收益（元）</p>
					<p class="djs">含待结算<strong>{{ userInfo.commissioSettled }}</strong>元</p>
				</li>
				<li @click="toPromoterOrder('total')">
					<p class="strong">{{ userInfo.orderCount }}</p>
					<p class="gray">累计订单</p>
				</li>
				<li @click="toPromoterList('total')">
					<p class="strong">{{ userInfo.customerCount }}</p>
					<p class="gray">累计客户</p>
				</li>
				<li v-if="userInfo.level_info" @click="toInvite()">
					<p class="strong">{{ userInfo.invitationCount }}</p>
					<p class="gray">累计邀请</p>
				</li>
			</ul>
			<p @click="toAssetsCenter()" class="content-a-p">可提现金额（元）<span><strong>{{ userInfo.commissioWithdrawal }}</strong><i class="iconfont icon-jiantou"></i></span></p>
		</div>
		<ul class="content-b">
			<li @click="toCommission('today')">
				<p class="strong">{{ userInfo.toDayCommissionCount }}</p>
				<p class="gray">今日收益（元）</p>
			</li>
			<li @click="toPromoterOrder('today')">
				<p class="strong">{{ userInfo.toDayOrderCount }}</p>
				<p class="gray">今日订单</p>
			</li>
			<li @click="toPromoterList('today')">
				<p class="strong">{{ userInfo.toDayCustomerCount }}</p>
				<p class="gray">今日新增客户</p>
			</li>
		</ul>
		<div class="content-c">
			<dl @click="$router.push('/user/promotion_product')">
				<dt class="iconfont icon-caigou"></dt>
				<dd>推广商品</dd>
			</dl>
			<dl v-if="userInfo.level_info" @click="$router.push('/user/invite_friend')">
				<dt class="iconfont icon-tuandui"></dt>
				<dd>邀请好友</dd>
			</dl>
			<dl v-if="userInfo.level_info" @click="$router.push('/user/poster')">
				<dt class="iconfont icon-haibao"></dt>
				<dd>推广海报</dd>
			</dl>
			<dl @click="$router.push('/user/commission_rank')">
				<dt class="iconfont icon-paihang"></dt>
				<dd>排行榜</dd>
			</dl>
			<dl v-if="discount_statu" @click="$router.push('/user/special_product')">
				<dt class="iconfont icon-caigou"></dt>
				<dd>折扣商品</dd>
			</dl>
			<!-- <dl v-if="discount_statu" @click="$router.push('/user/special_order/today')">
				<dt class="iconfont icon-caigou"></dt>
				<dd>折扣订单</dd>
			</dl> -->
		</div>
	</div>
  </div>
</template>
<script>
import { promotionIndex,getSpreadGoods_config } from "@api/user";

export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
	  isshow:false,
      userInfo: {},
	  discount_statu: false,
    };
  },
  watch: {
    $route(n) {
      if (n.name == "UserPromotion") this.getInfo();
    }
  },
  mounted: function() {
    this.getInfo();
	this.getSpreadGoodsConfig();
  },
  methods: {
	getSpreadGoodsConfig(){
            getSpreadGoods_config().then(res => {
				console.log(res);
                if(res.status == 200 && res.data.store_discount_statu == 1){
					this.discount_statu = true;
				}
            });
        },
    getInfo: function() {
      let that = this;
      promotionIndex().then(res => {
        that.userInfo = res.data;
		that.isshow = true;
      }).catch(err => {
		that.$dialog.message(err.msg);
		setTimeout(function(){
			that.$router.push('/');  
		},1000);
	  })
    },
	toCommission: function(time){
		this.$router.push({ path: "/user/commission/" + time });
	},
	toPromoterOrder: function(time){
		this.$router.push({ path: "/user/promoter_order/" + time });
	},
	toPromoterList: function(time){
		this.$router.push({ path: "/user/promoter_list/" + time });
	},
	toInvite: function(){
		this.$router.push({ path: "/user/promoter_invite/total" });
	},
	toAssetsCenter: function(){
		this.$router.push({ path: "/user/assets_center" });
	}
  }
};
</script>
<style scoped>
.promo-top{padding: 0 0.2rem;background: url(../../../assets/images/promotion_header_b.png) no-repeat top right;background-size: 50% 45%;background-color: #191919;}
.top-top{overflow: hidden;padding: 0.37rem 0.15rem;}
.top-left{float: left;}
.top-left img{width: 0.75rem;border-radius: 50%;}
.top-right{float: left;margin-left: 0.15rem;margin-top: -0.02rem;}
.top-right h2{color: #fff;font-size: 0.3rem;}
.top-right p{color: #fff;font-size: 0.24rem;}
.top-bottom{background-color: #e1bf8b;width: 100%;border-radius: 5px 5px 0 0;padding: 0.2rem 0.4rem;}
.top-bottom p{color: #714e11;font-size: 0.24rem;}
.top-bottom p span{color: #714e11;font-weight: bold;}
.bottom-title{overflow: hidden;}
.top-bottom p .title-l{font-size: 0.3rem;float: left;}
.top-bottom p .title-r{font-size: 0.26rem;float: right;}
.top-bottom p .title-r i{color: #714e11;font-size: 0.26rem;font-weight: bold;margin-left: 0.05rem;}
.bottom-i{margin-top: 0.1rem;}
.promo-content{padding: 0.2rem;}
.content-a{background-color: #fff;border-radius: 3px;padding: 0 0.3rem 0.2rem 0.3rem;}
.content-a ul{overflow: hidden;border-bottom: 1px solid #eee;}
.content-a ul li{width: 50%;float: left;height: 1.3rem;overflow: hidden;margin-top: 0.3rem;}
.content-a ul li .gray{color: #999;font-size: 0.24rem;}
.content-a ul li .strong{font-weight: bold;font-size: 0.35rem;}
.content-a ul li .djs{font-size: 0.24rem;color: #333;margin-top: 0.05rem;}
.content-a-p{margin-top: 0.2rem;font-size: 0.28rem;}
.content-a-p span{float: right;}
.content-a-p span strong{color: #fd7226;font-size: 0.3rem;}
.content-a-p span i{font-size: 0.28rem;color: #999;margin-left: 0.1rem;}
.content-b{background-color: #fff;border-radius: 3px;padding: 0.2rem 0.3rem;margin-top: 0.2rem;display: flex;justify-content: space-between;}
.content-b li{width: 30%;}
.content-b li .gray{color: #999;font-size: 0.24rem;}
.content-b li .strong{font-weight: bold;font-size: 0.35rem;}
.content-c{background-color: #fff;border-radius: 3px;padding: 0 0 0.2rem 0;margin-top: 0.2rem;overflow: hidden;}
.content-c dl{width: 25%;float: left;margin-top: 0.3rem;}
.content-c dl dt{font-size: 0.55rem;text-align: center;color: #e1bf8b;}
.content-c dl dd{text-align: center;margin-top: 0.05rem;}
</style>
